import {create} from 'zustand'
import {devtools} from 'zustand/middleware'
import type {SinceSource} from '../routes/route-payload-types'

type OverviewStoreState = {
  userSelection: SinceSource | null
  overviewStoreActions: {
    setUserSelection: (selection: SinceSource | null) => void
    resetUserSelection: () => void
  }
}

export const useOverviewStore = create<OverviewStoreState>()(
  devtools(
    set => ({
      userSelection: null,
      overviewStoreActions: {
        setUserSelection: selection => set({userSelection: selection}),
        resetUserSelection: () => set({userSelection: null}),
      },
    }),
    {name: 'overview-store'},
  ),
)
